import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BreadcrumbData } from '../breadcrumb-data';
import { BreadcrumbItem } from '../breadcrumb-item';

@Component({
  selector: 'yat-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  constructor(private route: ActivatedRoute, private router: Router) {}

  private routeData$: Observable<BreadcrumbData> = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    map(() => {
      let childRoute = this.route.root;
      while (childRoute.firstChild) {
        childRoute = childRoute.firstChild;
      }
      return childRoute.snapshot.data;
    })
  );

  breadcrumb$: Observable<Required<BreadcrumbItem>[] | null> = this.routeData$.pipe(
    map(data => {
      if (data.breadcrumb) {
        const stage = data.breadcrumbStage !== undefined ? data.breadcrumbStage : Infinity;
        return data.breadcrumb.map((item, i) => ({ active: i < stage, ...item }));
      } else {
        return null;
      }
    })
  );
}
